import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Grid,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tabs,
  Typography,
} from '@mui/material';

import { CustomerLocationOrder, OrderItem, SortProperties } from '../../store/config/types';
import {
  calculateDeliveryExpectedTime,
  formatDeliveryOrderTimeWindow,
  formatTimeWindow,
  getCustomerDisplayName,
} from '../../utils/string.helpers';
import './style.scss';

import { Store, LocationOn, CalendarToday, Person, Unarchive, Warning } from '@material-ui/icons';
import { useState } from 'react';
import DialogTitle from '@material-ui/core/DialogTitle';
import { deliveryOrdersService } from '../../services/deliveryOrders.service';

import DeliveryOrderPODView from './DeliveryOrderPODView';

import FilterableTable from '../FilterableTable/FilterableTable';
import DeliveryOrderActions from './DeliveryOrderActions';
import PackageGroupLink from '../PackageGroupLink/PackageGroupLink';
import {
  getCustomerLocationOrderStatus,
  getPackageGroupLabel,
  isOutsideTheTimeWindow,
} from '../../utils/deliveryOrders.helpers';
import { useHistory } from 'react-router-dom';
import GridContainer from '../Grid/GridContainer';
import GridItem from '../Grid/GridItem';
import moment from 'moment-timezone';
import CustomerLocationOrderStatus from './CustomerLocationOrderStatus';

interface DeliveryOrdersAccordionProps {
  deliveryOrders: CustomerLocationOrder[];
  title: string;
  timezone?: string;
  sortProps?: SortProperties;
  oldStyle?: boolean;
  /* eslint-disable */
  renderAdditionalActions?: () => JSX.Element;
  onSortClick?: (field: string) => void;
  onDeliveriesDelete?: (packageGroupIds?: number[]) => void;
  onError?: (message?: string) => void;
  /* eslint-enable */
}
const DeliveryOrdersAccordion = ({
  deliveryOrders,
  // title,
  timezone,
  // sortProps,
  // oldStyle,
  // renderAdditionalActions,
  // onSortClick,
  onDeliveriesDelete,
  onError,
}: DeliveryOrdersAccordionProps) => {
  const [deliveryToAction, setDeliveryToAction] = useState<CustomerLocationOrder | null>(null);
  const [packageGroupIdToAction, setPackageGroupIdToAction] = useState<number>();
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openPODView, setOpenPODView] = useState(false);
  const history = useHistory();

  const handleDeleteDialogClose = () => {
    setOpenDeleteDialog(false);
    setDeliveryToAction(null);
    setPackageGroupIdToAction(undefined);
  };
  const handlePODDialogClose = () => {
    setOpenPODView(false);
    setDeliveryToAction(null);
  };
  const handleMoreMenuClick = (deliveryOrder: CustomerLocationOrder, menuAction: string, id?: number) => {
    setDeliveryToAction(deliveryOrder);
    setPackageGroupIdToAction(id);
    switch (menuAction) {
      case 'delete':
        setOpenDeleteDialog(true);
        break;
      case 'pod':
        setOpenPODView(true);
        break;
      case 'edit':
        history.push('/delivery-orders/package-group/' + id);
        break;
      default:
        alert(`UNknown command: ${menuAction}${id ? ':' + id : ''}`);
    }
  };
  const handleDeleteDelivery = async () => {
    if (deliveryToAction) {
      const ids = packageGroupIdToAction
        ? [packageGroupIdToAction]
        : deliveryToAction.packageGroups.map((packageGroup) => packageGroup.packageGroupId ?? 0);
      try {
        const result: number[] = await deliveryOrdersService.deletePackageGroups(ids);
        if (result.length > 0) {
          handleDeleteDialogClose();
          onDeliveriesDelete && onDeliveriesDelete(result);
        }
      } catch (error: any) {
        if (onError && error.response && error.response.data.message) {
          onError(error.response.data.message);
        }
      }
    }
  };

  function renderdeliveryOrderDetails(row: any) {
    const deliveryOrder: CustomerLocationOrder = row.deliveryOrder;
    // let statusClass = getStatusOfAllPackageGroups(deliveryOrder, true);
    // let deliveryOrderSatus = deliveryOrder.status;
    const missTimeWindow = isOutsideTheTimeWindow(deliveryOrder, timezone);
    // if (missTimeWindow) {
    //   statusClass = 'NEEDS_ATTENTION';
    //   deliveryOrderSatus = getConclusionOfStatuses(['MISS_TIME_WINDOW']);
    // }
    return (
      <>
        {missTimeWindow && (
          <GridContainer>
            <GridItem xs={12}>
              <Typography color="error" className="doa-time-window-alert ">
                <Warning style={{ marginRight: 8 }} />
                {deliveryOrder.tripId &&
                  `${
                    (deliveryOrder.packageGroups[0]?.startDelayMinutes ?? 0 > 0) ? ' Due to late start, ' : ''
                  }Delivery Time (${moment(deliveryOrder.packageGroups[0].departure).format(
                    'hh:mm a',
                  )}) is outside the `}
                Requested Time Window ({formatDeliveryOrderTimeWindow(deliveryOrder, true)})
              </Typography>
            </GridItem>
          </GridContainer>
        )}
        <GridContainer>
          <GridItem xs={12}>
            <Tabs value={1} onChange={() => {}}>
              {/* <Tab label="Packages" value={0} /> */}
              <Tab label="Items" value={1} />
            </Tabs>

            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Source</TableCell>
                  <TableCell>ID</TableCell>
                  <TableCell>Description</TableCell>
                  <TableCell>Quantity</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {deliveryOrder.packageGroups
                  .reduce((allOrderItems, packageGroup) => {
                    return allOrderItems.concat(packageGroup.orderItems ?? []);
                  }, [] as OrderItem[])
                  .map((item, itemIndex) => (
                    <TableRow key={`item-${itemIndex}`}>
                      <TableCell>{item.externalSource}</TableCell>
                      <TableCell>{item.externalId ?? item.itemId}</TableCell>
                      <TableCell>{item.description}</TableCell>
                      <TableCell>{item.quantity}</TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </GridItem>
        </GridContainer>
      </>
    );
  }

  return (
    <>
      {/* <Typography variant="button">{title}</Typography> */}
      <FilterableTable
        columns={[
          {
            field: 'orderId',
            caption: 'ID',
            sortable: true,
            filterType: 'string',
            render: (row) => (
              <Grid container wrap="nowrap">
                <Grid item>
                  <DeliveryOrderActions deliveryOrder={row.deliveryOrder} onMenuSelect={handleMoreMenuClick} />
                </Grid>
                <Grid item>
                  <Grid container direction="column">
                    {row.deliveryOrder.packageGroups?.map((packageGroup: any) => (
                      <PackageGroupLink packageGroup={packageGroup} key={packageGroup.packageGroupId} />
                    ))}
                  </Grid>
                </Grid>
              </Grid>
            ),
          },
          { field: 'customer', caption: 'Customer', sortable: true, filterType: 'string' },
          { field: 'packages', caption: 'Packages', sortable: true },
          { field: 'shippingAddress', caption: 'Ship to', sortable: true, filterType: 'string' },
          { field: 'addressee', caption: 'Addressee', sortable: true, filterType: 'string' },
          { field: 'warehouse', caption: 'Warehouse', sortable: true, filterType: 'values' },
          {
            field: 'timeWindow',
            caption: 'Time window',
            sortable: true,
            filterType: 'string',
            render(row) {
              return formatTimeWindow(row.timeWindowFrom, row.timeWindowTo, true);
            },
          },
          {
            field: 'status',
            caption: 'Status',
            sortable: true,
            filterType: 'values',
            render: (row) => <CustomerLocationOrderStatus customerLocationOrder={row.deliveryOrder} />,
          },
        ]}
        data={deliveryOrders.map((d) => {
          let twFrom: string | undefined = '';
          let twTo: string | undefined = '';
          d.packageGroups.forEach((pg) => {
            if (pg.timeWindowFrom) {
              if (!twFrom || moment(pg.timeWindowFrom, 'HH:mm:dd').isAfter(moment(twFrom, 'HH:mm:dd'))) {
                twFrom = pg.timeWindowFrom;
              }
            }
            if (pg.timeWindowTo) {
              if (!twTo || moment(pg.timeWindowTo, 'HH:mm:dd').isAfter(moment(twTo, 'HH:mm:dd'))) {
                twTo = pg.timeWindowTo;
              }
            }
          });
          return {
            id: `${d.warehouseId}-${d.customerId}}`,
            deliveryOrder: d,
            orderId: d.packageGroups?.reduce((str, p) => {
              return str + ' ' + getPackageGroupLabel(p);
            }, ''),
            customer: getCustomerDisplayName(d.customer),
            packages: d.packageCount,
            shippingAddress: d.shippingLocation?.streetAddress,
            addressee: d.shipToAddressee,
            warehouse: d.warehouse?.name,
            shipVia: d.shipVia == 'DEFAULT' ? 'Curbinity' : d.shipVia,
            status: getCustomerLocationOrderStatus(d),
            timeWindow: formatTimeWindow(twFrom, twTo, false, true),
            timeWindowFrom: twFrom,
            timeWindowTo: twTo,
          };
        })}
        extendable
        renderExtended={renderdeliveryOrderDetails}
        itemPerPage={12}
        externalFilterValues={{}}
        primaryKey="k1"
      />
      <Dialog open={openDeleteDialog} onClose={() => handleDeleteDialogClose()}>
        <DialogTitle>Delete Delivery</DialogTitle>
        {deliveryToAction && (
          <DialogContent>
            <DialogContentText>
              <Grid container>
                <Grid item paddingRight={2}>
                  <Store />
                </Grid>
                <Grid item>
                  {deliveryToAction?.customer?.companyName} {deliveryToAction?.customer?.firstName}{' '}
                  {deliveryToAction?.customer?.lastName}
                </Grid>
              </Grid>
            </DialogContentText>
            <DialogContentText>
              <Grid container>
                <Grid item paddingRight={2}>
                  <Unarchive />
                </Grid>
                <Grid item>
                  <Grid container flexDirection={'column'}>
                    {deliveryToAction?.packageGroups
                      .filter((pg) => !packageGroupIdToAction || pg.packageGroupId == packageGroupIdToAction)
                      ?.map((pg) => (
                        <Grid item key={pg.packageGroupId}>
                          <PackageGroupLink packageGroup={pg} />
                        </Grid>
                      ))}
                  </Grid>
                  <Grid container>
                    {Math.ceil(
                      deliveryToAction?.packageGroups
                        .filter((pg) => !packageGroupIdToAction || pg.packageGroupId == packageGroupIdToAction)
                        ?.reduce((total, p) => total + (p.packageCount ?? 0), 0),
                    )}{' '}
                    Package(s)
                  </Grid>
                </Grid>
              </Grid>
            </DialogContentText>
            <DialogContentText>
              <Grid container>
                <Grid item paddingRight={2}>
                  <LocationOn />
                </Grid>
                <Grid item>{deliveryToAction?.shippingLocation?.streetAddress}</Grid>
              </Grid>
              {deliveryToAction.shipToAddressee && (
                <Grid container>
                  <Grid item paddingRight={2}>
                    <Person />
                  </Grid>
                  <Grid item>{deliveryToAction?.shipToAddressee}</Grid>
                </Grid>
              )}
            </DialogContentText>
            <DialogContentText>
              <Grid container>
                <Grid item paddingRight={2}>
                  <CalendarToday />
                </Grid>
                <Grid item>{calculateDeliveryExpectedTime(deliveryToAction, timezone) ?? ''}</Grid>
              </Grid>
            </DialogContentText>
          </DialogContent>
        )}
        <DialogActions>
          <Button color="success" variant="contained" onClick={() => handleDeleteDialogClose()}>
            Cancel
          </Button>
          <Button color="error" variant="outlined" onClick={() => handleDeleteDelivery()}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      <DeliveryOrderPODView handleClose={handlePODDialogClose} deliveryOrder={deliveryToAction} open={openPODView} />
    </>
  );
};

export default DeliveryOrdersAccordion;
